<template>
  <div>
    <login-as-tool />
  </div>
</template>

<script>
import LoginAsTool from '../../components/access/LoginAsTool';

export default {
  name: "skeleton-key",
  components: {
    LoginAsTool,
  },
};
</script>

<style scoped>
.login-as-tool {
  width: 30%;
  min-width: 400px;
}
</style>